import React from 'react';
import PopupContent from './Forms/HealthCondition';

interface PopupProps {
  closePopup: () => void;
}

const Popup: React.FC<PopupProps> = ({ closePopup }) => {
  return (
    <div className="popup-overlay">
      <div className="relative bg-white px-2 md:px-8 w-80 md:w-[32rem] rounded-lg text-left">
        <button onClick={()=>closePopup()} className="close-btn">
          &times;
        </button>        
       <PopupContent closePopups={closePopup}/>
      </div>
    </div>
  );
};


export default Popup;